<template>
    <div class="AdminDashboardPage">
        <DashboardSectionHeader title="Dashboard"/>

        <Row>
            <Column :md="6">
                <Row>
                    <Column :sm="6">
                        <DashboardStatsCard title="Companies" :amount="companyCount" icon="building"/>
                    </Column>
                    <Column :sm="6">
                        <DashboardStatsCard title="Drivers" :amount="driverCount" icon="truck"/>
                    </Column>
                </Row>

                <AdminLatestRegistrations :companies="latestCompanies"/>
            </Column>

            <Column :md="6">
                <IncomeChart/>
            </Column>
        </Row>
    </div>
</template>

<script>
import * as api from '@/api';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardStatsCard from '@/components/DashboardStatsCard';
import IncomeChart from './components/IncomeChart';
import AdminLatestRegistrations from './components/AdminLatestRegistrations';

export default {
    name: 'AdminDashboardPage',

    components: { DashboardSectionHeader, DashboardStatsCard, AdminLatestRegistrations, IncomeChart },

    data: () => ({
        companyCount: null,
        driverCount: null,
        latestCompanies: [],
    }),

    mounted() {
        this.fetchData();
    },

    methods: {
        async fetchData() {
            const res = await api.getAdminDashboard();
            if (res.error) {
                return this.$awn.alert('Failed to load dashboard data');
            }

            this.companyCount = res.body.companyCount;
            this.latestCompanies = res.body.latestCompanies;
            this.driverCount = res.body.driverCount;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AdminDashboardPage {
    .DashboardSectionHeader {
        margin-bottom: -30px;
    }

    .Card {
        margin-top: 30px;
    }
}
</style>
